import { z } from 'zod';
export const paginationSchema = z.object({
    page: z.coerce.number().int().positive().default(1),
    pageSize: z.coerce.number().int().positive().max(200).default(20),
    search: z.string().optional(),
});
export function successResponse(data, message) {
    return {
        success: true,
        data,
        ...(message ? { message } : {}),
    };
}
export function errorResponse(error, details) {
    return {
        success: false,
        error,
        ...(details === undefined ? {} : { details }),
    };
}
export function paginatedData(items, total, page, pageSize) {
    return {
        items,
        total,
        page,
        pageSize,
        totalPages: Math.ceil(total / pageSize),
    };
}
